import { View, type ViewProps } from 'react-native';

import { colors, radius, shadows, spacing } from '@/theme/tokens';

/** Elevated white card with the soft ambient navy shadow ("pillow" effect) */
export function Card({ style, ...rest }: ViewProps) {
  return (
    <View
      {...rest}
      style={[
        {
          backgroundColor: colors.card,
          borderRadius: radius.card,
          padding: spacing.screen,
          ...shadows.card,
        },
        style,
      ]}
    />
  );
}
